import { render, staticRenderFns } from "./EditIndustryTypesComponent.vue?vue&type=template&id=583a00e8&"
import script from "./EditIndustryTypesComponent.vue?vue&type=script&lang=js&"
export * from "./EditIndustryTypesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports